import { NavHome } from './components/navHome/NavHome';
import { CompanyInfo } from './components/companyInfo/companyInfo';
import { LandingPage } from './components/landingPage/LandingPage';
import { Blog } from './components/blog/blog';
import { ContactUs } from './components/contactUs/ContactUs';
import { Footer } from './components/footer/Footer';

function App() {
  return (
    <div className="App">
      <NavHome />
      <LandingPage />
      <CompanyInfo />
      <Blog />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default App;
